/**
 * @file The label of every Metrics series grain, keyed by grain. Consumers:
 * the Metrics explorer's Time Period options and the series table's first
 * column header. The `Record` type fails the build when a grain is added
 * without a label.
 */
import type { AnalyticsSeriesGrain } from '#types';

export const ANALYTICS_SERIES_GRAIN_LABELS: Record<
  AnalyticsSeriesGrain,
  string
> = {
  day: 'Day',
  week: 'Week',
  month: 'Month',
  quarter: 'Quarter',
};
